import { useCallback, useEffect, useState } from 'react';
import { API_ORIGIN } from '../utils/homeHelpers';

const useServerClock = ({ setTriviaStartedAt }) => {
  const [clockOffsetMs, setClockOffsetMs] = useState(0);

  const fetchServerNow = useCallback(async () => {
    try {
      const r = await fetch(`${API_ORIGIN}/api/trivia/now`, {
        credentials: 'include',
      });
      if (!r.ok) return null;

      const data = await r.json();
      if (data && data.ok && typeof data.now === 'number') {
        const offset = data.now - Date.now();
        setClockOffsetMs(offset);
        setTriviaStartedAt((prev) => prev || (Date.now() + offset));
        return data.now;
      }
    } catch (e) {
      console.warn('failed to sync clock', e);
    }

    return null;
  }, [setTriviaStartedAt]);

  useEffect(() => {
    fetchServerNow();
  }, [fetchServerNow]);

  const syncServerTime = useCallback(async () => {
    try {
      const r = await fetch(`${API_ORIGIN}/api/trivia/now`, {
        credentials: 'include',
      });
      if (!r.ok) return null;

      const j = await r.json();
      if (j && j.ok && typeof j.now === 'number') {
        const clientNow = Date.now();
        const off = j.now - clientNow;
        setClockOffsetMs(off);
        return j.now;
      }
    } catch {}

    return null;
  }, []);

  return {
    clockOffsetMs,
    syncServerTime,
  };
};

export default useServerClock;
